// project imports
// action - state management
import * as actionTypes from "../../actions/actionTypes";
import { years } from "store/utils/years";
import { nwcMonths } from "./staticYearsData";

// This is to filter based on company types
import { SaaSCoType, GeneralCoType } from "constants/companyTypes";

// subscriber acquisition assumption' keys
export const NWC_KEY = "nwc";

export const initialState = {
  [NWC_KEY]: {
    unit: "PERCENTAGE",
    unitSymbol: "%",
    companyTypes: [SaaSCoType, GeneralCoType],
    years: {
      [years.YEAR_1_KEY]: 1,
      [years.YEAR_2_KEY]: -2,
      [years.YEAR_3_KEY]: 3,
      [years.YEAR_4_KEY]: 1,
      [years.YEAR_5_KEY]: 1,
    },
    // years:nwcMonths,
    months: nwcMonths,
  },
};

// ==============================|| NET WORKING CAPITAL ASSUMPTIONS REDUCER ||============================== //

const netWorkingCapitalAssumptionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_NET_WORKING_CAPITAL_ASSUMPTION_BY_YEAR:
      return {
        ...state,
        [action.key]: {
          ...state[action.key],
          years: {
            ...state[action.key].years,
            [action.yearKey]: [action.amount],
          },
        },
      };
    case actionTypes.SET_NET_WORKING_CAPITAL_ASSUMPTION_BY_MONTHS:
      return {
        ...state,
        [action.key]: {
          ...state[action.key],
          months: {
            ...state[action.key].months,
            [action.yearKey]: [action.amount],
          },
        },
      };
    case actionTypes.RESET_NET_WORKING_CAPITAL_ASSUMPTION_REDUCER:
      return initialState;
    default:
      return state;
  }
};

export default netWorkingCapitalAssumptionsReducer;
